// LOADER
// ------

$(document).ready(function(){

	$('#loader').css({
		'width' : $(document).width(),
		'height' : $(document).height()
	}).delay(500).fadeOut(500);

});

$(document).on('load', function(){

	$('#loader').css({
		'width' : $(document).width(),
		'height' : $(document).height()
	}).delay(500).fadeOut(500);

});